import { PATH_LOGIN } from "../../constants/routes";

/**
 * Check if the API response indicates malware was detected.
 * Backend returns 403 with { malwareDetected: true } in JSON body.
 * Also supports checking the parsed JSON response body.
 */
export const isMalwareDetected = (statusCode: number): boolean => {
  return statusCode === 403;
};

/**
 * Check response body for malware detection flag.
 * Use this after checking status code for more reliable detection.
 */
export const isMalwareResponse = (responseData: any): boolean => {
  return responseData?.malwareDetected === true;
};

/**
 * Handle malware detection: clear all browser data, cookies, and redirect to login.
 * Returns a never-resolving promise to prevent further execution in the caller.
 */
export const handleMalwareDetection = (): Promise<never> => {
  console.error('🚨 MALWARE DETECTED - Initiating security response');
  
  // Step 1: Clear all browser data immediately
  clearBrowserData();
  
  // Step 2: Redirect to login with security reason
  // No need to call performLogout — backend already cleared cookies & blacklisted tokens
  const loginUrl = `${window.location.origin}${PATH_LOGIN}?reason=security`;
  window.location.href = loginUrl;
  
  // Return never-resolving promise to halt caller execution
  return new Promise(() => {});
};

/**
 * Clear all browser-side data: localStorage, sessionStorage, cookies, IndexedDB
 */
const clearBrowserData = (): void => {
  try {
    // Clear storage
    localStorage.clear();
    sessionStorage.clear();

    // Clear all cookies (including those the browser can access)
    document.cookie.split(";").forEach(cookie => {
      const name = cookie.split("=")[0].trim();
      // Clear with multiple path variants to ensure removal
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
    });

    // Clear IndexedDB
    if (window.indexedDB) {
      indexedDB.deleteDatabase('career-card-data');
    }

    // Clear any cached data in Redux store by reloading
    // (the redirect will handle this)
  } catch (error) {
    console.warn('Browser cleanup error:', error);
  }
};
